import styled from 'styled-components'
import ReactSelect from 'react-select'
import colors from '../../theme/colors'
import fonts from '../../theme/fonts'

const BORDER_RADIUS = '8px'

export const Wrapper = styled.div`
  width: 100%;

  h1 {
    font-size: 16px;
    font-weight: 500;
    line-height: 16px;
    letter-spacing: 0.01em;
  }
`

export const Label = styled.label`
  margin-bottom: 8px;
`

export const Select = styled(ReactSelect)`
  * {
    font-family: ${fonts.fontFamilies.Inter};
  }

  ${({ disabled = false }) => disabled && `
    * {
      color: ${colors.Primary.Grey};
      background-color: ${colors.Primary.GreyLight};
    }
  `}

  .select {
    &__value-container,
    &__control {
      padding-top: 0;
      padding-bottom: 0;
    }

    &__value-container {
      height: 48px;
    }

    &__control {
      border-color: hsl(0, 0%, 80%);
      border-radius: ${BORDER_RADIUS};
      border-style: solid;
      border-width: 1px;

      &:hover {
        border-color: ${colors.Primary.yellow500};
      }

      &--is-focused {
        border-color: ${colors.Primary.yellow600};
        box-shadow: 0 0 1px ${colors.Primary.yellow600};
      }
    }

    &__indicator-separator {
      display: none;
    }

    &__menu {
      border-radius: ${BORDER_RADIUS};
    }

    &__menu-list {
      border-radius: ${BORDER_RADIUS};
      padding: 8px 0;
    }

    &__option {
      display: flex;
      align-items: center;
      background-color: transparent;
      color: black;
      height: 40px;
      line-height: normal;

      &--hover,
      &--is-focused,
      &:active {
        background-color: ${colors.Primary.GreyLight};
        cursor: pointer;
      }
    }

    &__single-value {
      display: flex;
      align-items: center;
      width: 100%;
      line-height: 32px;
    }
  }

  ${({ isValid }: { isValid: boolean }) =>
    !isValid &&
    `
    .select__control {
      border-color: ${colors.Action.ErrorRed};
    }
  `}
`
